var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6700\\u7EC8\\u5B9A\\u7A3F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0\\u589E",
    transform: "translate(-658.000000, -913.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(575.000000, 913.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Twitter",
    transform: "translate(83.004941, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 39.985176,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.992588,0 C31.065436,0 39.985176,8.92304688 39.985176,20 C39.985176,31.0769531 31.065436,40 19.992588,40 C8.91974,40 0,31.0769531 0,20 C0,8.92304688 8.91974,0 19.992588,0 Z M17.2709943,12.8571429 L17.2177516,12.8572862 C16.8562342,12.8628601 14.7084874,12.9683275 12.4611336,14.6429808 C12.4611336,14.6429808 12.4108308,14.7335672 12.3245973,14.9048235 L12.3245973,14.9048235 L12.2422188,15.0711392 C11.638836,16.3085331 9.99629401,20.0875334 9.99629401,24.5578487 C9.99629401,24.5578487 11.4341171,27.0238107 15.2169613,27.1428571 C15.2169613,27.1428571 15.8502881,26.3775586 16.3637964,25.7313065 C14.3452199,25.1312152 13.492604,23.9152409 13.3811006,23.7445919 L13.3811006,23.7445919 L13.3683315,23.7245236 L13.4575733,23.784466 C13.7077119,23.9475651 14.0392206,24.1291988 14.0701262,24.1496895 C16.9592787,25.757215 21.0631992,26.2838892 24.7510978,24.7449217 C25.3501908,24.5238354 26.0177515,24.2007094 26.7195461,23.7415302 C26.7195461,23.7415302 25.8636991,25.1360743 23.6213797,25.7653198 C24.0706994,26.3307903 24.5986501,26.9613645 24.7236171,27.1101725 L24.7510978,27.1428571 C28.533942,27.0238107 29.988882,24.5578487 29.988882,24.5578487 C29.988882,19.0817124 27.5240424,14.6429808 27.5240424,14.6429808 C25.2766886,12.9683275 23.1289418,12.8628601 22.7674244,12.8572862 L22.7674244,12.8572862 L22.7141818,12.8571429 L22.4745446,13.1293903 L22.7603481,13.219067 C25.4730714,14.0973513 26.7366631,15.2892329 26.7366631,15.2892329 C22.6706539,13.0751153 17.8944254,13.0747167 13.9503076,14.7960405 C13.7067203,14.9072377 13.5011144,15.0058561 13.3403071,15.0851223 L13.3403071,15.0851223 L13.1692779,15.1705193 C13.0206247,15.2457603 12.940408,15.2892329 12.940408,15.2892329 C12.940408,15.2892329 14.3611142,13.9457088 17.4421637,13.0613638 L17.4421637,13.0613638 L17.2709943,12.8571429 Z M23.0394037,19.2007588 C24.0150693,19.2007588 24.7853317,20.0510906 24.7853317,21.0884953 C24.7853317,22.1259 24.0150693,22.9762317 23.0394037,22.9762317 C22.0808549,22.9762317 21.2934756,22.1259 21.2934756,21.0884953 C21.2934756,20.0510906 22.063738,19.2007588 23.0394037,19.2007588 Z M16.7917199,19.2007588 C17.7673856,19.2007588 18.5547649,20.0510906 18.537648,21.0884953 C18.537648,22.1259 17.7673856,22.9762317 16.7917199,22.9762317 C15.8331712,22.9762317 15.0457918,22.1259 15.0457918,21.0884953 C15.0457918,20.0510906 15.8160542,19.2007588 16.7917199,19.2007588 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#0E0905"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiscord);
export default __webpack_public_path__ + "static/media/ic_discord.25ce9f720b50a1e3ee90527dccd3964c.svg";
export { ForwardRef as ReactComponent };